module.exports = __webpack_public_path__ + "img/hearing-aid2.20fe6670749af3cd2e6a296b14dd5f10.png";